import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_conhecimento_transporte_documentos = _resolveComponent("conhecimento-transporte-documentos")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_conhecimento_transporte_impostos = _resolveComponent("conhecimento-transporte-impostos")!
  const _component_conhecimento_transporte_financeiro = _resolveComponent("conhecimento-transporte-financeiro")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_tab_pane, {
        key: "1",
        tab: "Documentos Referenciados"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_conhecimento_transporte_documentos, {
            documentos: _ctx.documentos,
            "onUpdate:documentos": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:documentos', value))
          }, null, 8, ["documentos"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, {
        key: "2",
        tab: "Impostos"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_conhecimento_transporte_impostos, {
            impostos: _ctx.impostos,
            "onUpdate:impostos": _cache[1] || (_cache[1] = (value) => _ctx.$emit('update:impostos', value))
          }, null, 8, ["impostos"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_tab_pane, {
        key: "3",
        tab: "Financeiro"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_conhecimento_transporte_financeiro)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}